export enum DisplayMode {
  RANGE = 'range',
  ROUTE = 'route',
  NAVIGATION = 'navigation',
  SHOW_ON_MAP = 'show_on_map'
}